import { useRef, useState } from "react";
import Footer from "../../../core/common/Footer";
import { PageBreadcrumb } from "../../../core/common/BreadCrumbForm";
import handleClearError from "../../../core/methods/handleClearError";
import ErrorMessage from "../../../core/common/ErrorMessage";
import useApi from "../../../core/customhook/useApi";
import {
  SearchFilterRef,
  SearchPayload,
} from "../../../core/common/ManagerSingleSearchFilter/types"; 
import { formatDate } from "../../../core/common/TabelValue";
import { safeLocaleCompare } from "../../../core/methods/sorterMethods";
import { cellWidth } from "../../../core/methods/tableCellWidth";
import { ColumnsType } from "antd/es/table";
import Datatable from "../../../core/common/dataTable";
import { useAuth } from "../../../core/context/useAuthContext";
import Swal from "sweetalert2";

const initialData = {
  name: "",
  phone: "",
  email: "",
};
 
const breadcrumbItem = [{ label: "Add Verifier" }];

const ManagerAddVerifier = () => {
  const { auth } = useAuth();
  const agency_id = auth?.agency_id;
  const manager_user_id = auth?.agency_user_id;
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState<any>({}); 
  const [tableData, setTableData] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [showTable, setShowTable] = useState(false);
 
  const manager_addVerifier = useApi<any>("/api/v1/agency/agency-verifyer", {
    method: "POST",
    autoCall: false,
    handleGlobalError: false,
  });

  const initialSearchData: SearchPayload = {
  org_ids: [],
  project_ids: [],
  location_name: [],
  program_ids: [],
  department_ids: [],
  };
  const [searchData, setSearchData] =
    useState<SearchPayload>(initialSearchData); 
  const validationCheck = () => {
    const newError: any = {};
    const { name, phone, email } = formData;

    if (!name?.trim()) {
      newError.name = "Please Enter Verifier name.";
    }
    if (!email?.trim()) {
      newError.email = "Email is required.";
    }
    if (!phone?.trim()) {
      newError.phone = "Contact number is required.";
    }

    setErrors(newError);
    return Object.keys(newError)?.length == 0;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    handleClearError(setErrors, name);
  };
 
  const handleAddVerifier = async () => {
    const isValid = validationCheck();

    if (!isValid) return;
 
    const programs = tableData
      .filter((row) => selectedRows?.includes(row.assignment_id))
      .map((row) => ({
        case_id: row.assignment_id,
        package_id: row.package_id,
        org_id: searchData.org_ids,
        project_id: searchData.project_ids,
        program_id: searchData.program_ids,
        department_id: searchData.department_ids,
      }));

    const payload = {
      agency_id: agency_id,
      full_name: formData.name,
      email: formData.email,
      phone: formData.phone,
      agency_user_profile: "VERIFIER",
      manager_user_id: manager_user_id,
      programs,
    };

    try {
      const res = await manager_addVerifier.callApi(payload);

      if (!res?.success) {
        await Swal.fire({
          icon: "error",
          title: "Failed",
          text: res?.error || res?.message || "Something went wrong.",
          confirmButtonText: "OK",
        });

        return;
      }
      await Swal.fire({
        icon: "success",
        title: "Success",
        text: res?.message || "Verifier added successfully.",
        timer: 1500,
        showConfirmButton: true,
      });
      setFormData(initialData);
      setSelectedRows([]);
    } catch (error: any) {
      await Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error?.response?.data?.error ||
          error?.message ||
          "Something went wrong.",
      });
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "S.No",
      key: "sno",
      width: 70,
      align: "center",
      render: (_: any, __: any, index: number) => index + 1,
    },
    {
      title: "Applicant Name",
      dataIndex: "applicant_name",
      key: "applicant_name",
      onCell: () => cellWidth(200),
      sorter: (a, b) => safeLocaleCompare(a, b, "applicant_name"),
    },
    {
      title: "Case ID",
      dataIndex: "case_id",
      key: "case_id",
      onCell: () => cellWidth(190),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_id"),
    },
    {
      title: "Case SPOC",
      dataIndex: "case_spoc",
      key: "case_spoc",
      onCell: () => cellWidth(150),
      sorter: (a, b) => safeLocaleCompare(a, b, "case_spoc"),
    },

    {
      title: "Candidate ID",
      dataIndex: "hrms_id",
      key: "hrms_id",
      onCell: () => cellWidth(150),
      sorter: (a, b) => safeLocaleCompare(a, b, "hrms_id"),
    },
    {
      title: "Case Received",
      dataIndex: "case_received_date",
      key: "case_received_date",
      render: (value: string) => formatDate(value),
      onCell: () => cellWidth(150),
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      key: "due_date",
      render: (value: string) => formatDate(value),
      onCell: () => cellWidth(150),
    },
    {
      title: "Total Checks",
      dataIndex: "total_checks",
      key: "total_checks",
      align: "center",
      width: 120,
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   width: 120,
    //   render: (_: any, record: any) => (
    //     <button
    //       type="button"
    //       className="btn btn-sm btn-primary"
    //       // onClick={() => handleAssign(record)}
    //     >
    //       <i className="ti ti-check me-1"></i>
    //       Assign
    //     </button>
    //   ),
    // },
    {
      title: "Select",
      key: "select",
      width: 90,
      align: "center",
      render: (_: any, record: any) => (
        <input
          type="checkbox"
          className="form-check-input"
          style={{
            transform: "scale(1.35)",
            cursor: "pointer",
          }}
          checked={selectedRows.includes(record.assignment_id)}
          onChange={(e) => {
            if (e.target.checked) {
              setSelectedRows((prev) => [...prev, record.assignment_id]);
            } else {
              setSelectedRows((prev) =>
                prev.filter((id) => id !== record.assignment_id),
              );
            }
          }}
        />
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content pb-5"> 
        <PageBreadcrumb title="Add Verifier" breadcrumbs={breadcrumbItem} /> 

        {/* add Verifier */}
        <div className="card shadow-sm border-0">
          <div className="card-body">
            {/* Heading */}
            <div className="mb-3">
              <h5 className="fw-bold mb-1">Add Verifier</h5>
              <p className="text-muted mb-0">Enter verifier details.</p>
            </div>

            {/* Verifier Details */}
            <div className="row g-3">
              <div className="col-6 col-md-4">
                <label htmlFor="name" className="form-label">
                  Verifier name
                </label>
                <input
                  type="text"
                  className="form-control mb-1 text-capitalize"
                  name="name"
                  id="name"
                  value={formData?.name ?? ""}
                  placeholder="Full name"
                  onChange={handleChange}
                />
                <ErrorMessage message={errors?.name} />
              </div>
              <div className="col-6 col-md-4">
                <label htmlFor="email" className="form-label">
                  Email
                </label>
                <input
                  type="text"
                  className="form-control mb-1"
                  name="email"
                  id="email"
                  value={formData?.email ?? ""}
                  placeholder="you@example.com"
                  onChange={handleChange}
                />
                <ErrorMessage message={errors?.email} />
              </div>
              <div className="col-6 col-md-4">
                <label htmlFor="phone" className="form-label">
                  Contact
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  className="form-control mb-1"
                  name="phone"
                  value={formData?.phone ?? ""}
                  placeholder="Phone number"
                  onChange={(e) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);

                    setFormData((prev: any) => ({
                      ...prev,
                      phone: value,
                    }));

                    handleClearError(setErrors, "phone");
                  }}
                />
                <ErrorMessage message={errors?.phone} />
              </div>
            </div>

            {/* add verifier button */}
            <div className="text-end mt-3">
              <button
                type="button"
                onClick={handleAddVerifier}
                className="btn btn-primary"
                style={{}}
              >
                {manager_addVerifier.loading ? (
                  "Adding..."
                ) : (
                  <>
                    <i className="ti ti-plus"></i> Add Verifier
                  </>
                )}
              </button>
            </div>
{/* 
            <hr
              className="mt-3 mb-4"
              style={{
                border: "none",
                height: "2px",
                background: "#333",
              }}
            /> */}

            {/* Search Filter */}

            {/* <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between mb-3">
                <div>
                  <h5 className="mb-1 fw-bold">Search Filters</h5>
                  <p className="text-muted mb-0 small">
                    Select the required filters to search cases.
                  </p>
                </div>
              </div>

              <SearchFilter
                ref={filterRef}
                value={searchData}
                onChange={setSearchData}
                storageKey="manager_addVerifier"
              />
            </div> */}

            {/* Buttons */}

            {/* <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn btn-primary px-4"
                onClick={handleSearch}
                disabled={searchCaseAPI.loading}
              >
                <i className="ti ti-search me-1"></i>

                {searchCaseAPI.loading ? "Searching..." : "Search"}
              </button>

              <button
                className="btn btn-outline-secondary px-4"
                onClick={handleClear}
              >
                <i className="ti ti-refresh me-1"></i>
                Clear
              </button>
            </div> */}
          </div>
        </div>
        {showTable && (
          <div className="card mt-4">
            <div className="card-body">
              <Datatable
                dataSource={tableData}
                columns={columns}
                rowKey="assignment_id"
                Selection={false}
              />
            </div>
          </div>
        )}

        {/* {showTable && ( */}
        {/* <div className="text-end my-4">
            <button
              type="button"
              onClick={handleAddVerifier}
              className="btn btn-primary"
            >
              <i className="ti ti-plus"></i> Add Verifier
            </button>
          </div> */}
        {/* )} */}
      </div>

      <Footer />
    </div>
  );
};

export default ManagerAddVerifier;
